import PropTypes from 'prop-types';

export const offerShape = {
  id: PropTypes.string,
  collectionAddress: PropTypes.string,
  price: PropTypes.string,
  globalBidAmount: PropTypes.number,
  filledGlobalBids: PropTypes.number,
  traitFilter: PropTypes.object,
  rarityFilter: PropTypes.object,
  end: PropTypes.number,
  issuer: PropTypes.string,
  status: PropTypes.string,
  isReady: PropTypes.bool,
  isExpired: PropTypes.bool,
  isApprovedEnough: PropTypes.bool,
  hasEnoughBalance: PropTypes.bool,
  signature: PropTypes.string,
  chain: PropTypes.string,
  fromUser: PropTypes.object,
};
